import moment from 'moment';

export const FORM_MAP = {
  RANGE_TIME: 'rangeTime',
  RANGE_TIME_DIFF: 'diff',
  RANGE_TIME_TYPE: 'timeType',
  SINGLE_TIME: 'singleTime',
  REGION: 'region',
  SYSTEM: 'system',
  COMPETITOR: 'competitor',
  SOURCE: 'source',
  DAY_MONTH: 'dayMonth',
  SWITCH: 'switchDatePicker',
  CAN_FETCH: 'canFetch',
  GAME_CODE_RELEASE_TIME: 'gameCodeReleaseTime'
};

export const DEFAULT_FILTER_VALUE = {
  RANGE_TIME_DAY: [moment().subtract(30, 'day').format('YYYY-MM-DD'), moment().subtract(1, 'day').format('YYYY-MM-DD')],
  RANGE_TIME_WEEK: [moment().subtract(8, 'week').startOf('week').format('YYYY-MM-DD'), moment().subtract(1, 'week').endOf('week').format('YYYY-MM-DD')],
  RANGE_TIME_MONTH: [moment().subtract(6, 'month').startOf('month').format('YYYY-MM-DD'), moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')],
  RANGE_TIME_TYPE: 'Month',
  SINGLE_TIME: moment().subtract(1, 'day').format('YYYY-MM-DD'),
  COMPETITOR: [],
  REGION: {
    regions: [],
    markets: ['255'],
    region_type: 'market'
  },
  SYSTEM: ['255'],
  SOURCE: '',
  DAY_MONTH: {
    type: 'Day',
    value: ['1', '30']
  },
  SWITCH: false,
  CAN_FETCH: false,
  GAME_CODE_RELEASE_TIME: ''
};

export const TAB_NAME: any = {
  Day: 'daily',
  Week: 'weekly',
  Month: 'monthly'
};

export const REVENUE_TRENDS_TABLIST = [
  { text: 'Revenue', value: 'Revenue' },
  { text: 'Adjusted Revenue', value: 'Adjusted Revenue' },
];

export const RETENTION_TRENDS_TABLIST = [
  { text: 'Avg.D2', value: 'Avg.D2' },
  { text: 'Avg.D3', value: 'Avg.D3' },
  { text: 'Avg.D7', value: 'Avg.D7' },
  { text: 'Avg.D15', value: 'Avg.D15' },
  { text: 'Avg.D31', value: 'Avg.D31' },
];

export const DWM: any = {
  Day: 'DAU Trends',
  Week: 'WAU Trends',
  Month: 'MAU Trends',
  LaunchMonth: 'Avg.DAU Trends'
};

export const rightIcon = [
  {
    icon: 'earch-other',
    bubble: 'line',
  },
  {
    icon: 'sheet',
    bubble: 'sheet',
  },
];

export const appannieTypeSourceList= ['appannie', 'sensortower'];

export const adjustedtabTypeSourceList= ['appannie'];

// dataFrame / gameCode 维度配置 ——————————————————————————————————————

/** Source 筛选器：需要过滤掉的 source value 列表（dataFrame 维度，优先级高于 gameCode） */
export const DATA_FRAME_SOURCE_EXCLUDE_MAP: Record<string, string[]> = {
  casual: ['appannie', 'ogdb'],
};

/** Source 筛选器：需要过滤掉的 source value 列表（gameCode 维度） */
export const GAME_SOURCE_EXCLUDE_MAP: Record<string, string[]> = {
  // arrows: ['appannie', 'ogdb'],
};

/** 日期筛选器：只允许选中的粒度列表 + 默认粒度 */
export const GAME_DATE_TYPE_MAP: Record<string, { typeList: string[]; defaultType: string; }> = {
  arrows: { typeList: ['date'], defaultType: 'date' },
};

/**
 * 宽表：按 alignedBy 筛选器开关状态隐藏的指标列（对应 COLUMNS_CONFIG 中的 value）
 * - normal: 开关关闭时隐藏的指标
 * - alignedBy: 开关打开时隐藏的指标
 *
 * 示例：同时配置两种状态
 * arrows: { normal: ['tru', 'total_revenue'], alignedBy: ['tru'] },
 */
export const GAME_HIDDEN_METRICS_MAP: Record<string, { normal?: string[]; alignedBy?: string[]; }> = {
  // arrows: { normal: ['tru'], alignedBy: ['tru'] },
};

/** 进入页默认排序（dataFrame 维度，优先级高于 gameCode） */
export const DATA_FRAME_TABLE_ENTRY_SORT_MAP: Record<string, { sortedBy: string; desc?: boolean; }> = {
  casual: { sortedBy: 'dau', desc: true },
};

/** 进入页默认排序（gameCode 维度） */
export const GAME_TABLE_ENTRY_SORT_MAP: Record<string, { sortedBy: string; desc?: boolean; }> = {
  // 示例: arrows: { sortedBy: 'revenue', desc: true },
};

// Casual 模式指标 explain 配置
export const CASUAL_METRIC_EXPLAIN: Record<string, { en: string; cn: string; }> = {
  DAU: {
    en: 'Daily Active Users.Number of users who have logged in to the game during the statistical period',
    cn: '日活跃用户数：当天至少打开过一次应用的独立用户数。',
  },
  WAU: {
    en: 'Weekly Active Users.Number of users who have logged in to the game during the statistical period.',
    cn: '统计周期内登录过游戏的用户数',
  },
  MAU: {
    en: 'Monthly Active Users.Number of users who have logged in to the game during the statistical period.',
    cn: '统计周期内登录过游戏的用户数',
  },
  NEW: {
    en: 'New Register Users.Total number of newly-registered users in the statistical period',
    cn: '新增用户数：在所选时间段内首次安装并打开应用的用户数。',
  },
  TNU: {
    en: 'Total New Users. Total number of registered users accumulated to the statistical day',
    cn: '累计新增用户数：自应用上线以来累计获取的新用户总数。',
  },
};